module.exports = __webpack_public_path__ + "static/Aviso de privacidad EDUCAMED-691aa29f39800c1fc83b9b75585521dd.pdf";